//=================================================================
// Web Push通知用スクリプト(ブラウザー用)
//=================================================================

// Firebase
import { getToken, getMessaging, onMessage } from "@firebase/messaging";
import firebase from "firebase/compat/app";
import "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";

// メモった！、キニッタ！共通
import * as GFunc from '@/components/00/Common00';    // 共通メソッド

// キニッタ！専用
import * as LVar from '@/components/05/Var05001';     // キニッタ！専用変数
import * as LFunc from '@/components/05/Common05001'; // キニッタ！専用メソッド

// サービスワーカーを登録する
let serviceWorkerRegistration: any; 

// 通知の許可を求める
export async function initializePushNotification() {
  try {
    // Firebase初期化
    firebase.initializeApp(LVar.firebaseConfig);
    // サービスワーカー登録
    if (process.env.NODE_ENV === 'production') {
      serviceWorkerRegistration = await navigator.serviceWorker.register(`${process.env.BASE_URL}firebase-messaging-sw.js`);
    }
    // 通知許可取得
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      console.log('通知の許可が与えられました');
      // 許可されたら、FCMトークンを取得する処理をサービスワーカーに依頼
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
          requestFCMToken();
        });
      }
    } else {
      console.error('通知の許可がありません');
    }
  } catch (error) {
    console.error('通知の許可を取得中にエラー:', error);
  }
}

// トークンを取得する
async function requestFCMToken() {
  try {
      // Firebase Messaging を初期化
      const messaging = getMessaging();

      // トークンを取得（serviceWorkerRegistration を指定）
      console.log("トークン取得中");
      const token = await getToken(messaging, {
          vapidKey: LFunc.getProperty("firebase.vapid.key"), // Firebase コンソールで取得した公開鍵を設定
          serviceWorkerRegistration: serviceWorkerRegistration,
      });
      // トークンを保存する
      GFunc.saveTrmnlTkn(token);

      if (token) {
          console.log("FCM Token:"+token);
      } else {
          console.log('登録トークンがありません。生成する許可をリクエストします。');
      }
  } catch (err) {
      console.error('エラーが発生しました:', err);
  }
}

 